/**
 * Created by Misa.Qarahqani on 8/21/2019.
 */
import * as React from "react";
import {connect} from "react-redux";
import {Avatar, Col, Form, Icon, Input, Row} from 'antd';
import {FormattedMessage} from "react-intl";
import ImagePicker from "@components/custom/imagePicker";
import ModalForm from "@hocs/ModalForm";
import {Image} from "@models/image";
import {User} from "@models/user";
import {updateRequest} from "@actions/auth";
import {ApplicationState} from "@reducers/index";
import {REGEX_PATTERNS} from "../../constants/regex";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  user?: User,
}

interface PropsFromDispatch {
  updateRequest: typeof updateRequest;
}

type ProfileFormAllProps = PropsFromState & PropsFromDispatch


interface ProfileFormStateShape extends User {
  visible: boolean;
  avatar: Image | null;
  id: string;
  name: string;
  username: string;
  email: string;
  mobile: string;
  avatar_url: string;
}


class Profile extends React.Component<ProfileFormAllProps, ProfileFormStateShape> {
  constructor(props) {
    super(props);
    const {profile} = props;
    this.state = {
      visible: false,
      name: profile.name || "",
      username: profile.username || "",
      email: profile.email || "",
      mobile: profile.mobile || "",
      avatar_url: profile.avatar_url || "",
      id: profile.id,
      avatar: profile.avatar || ""
    };
  }
  
  getValues = () => {
    let returnValues = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
          avatar_url: values.avatar_url ? values.avatar_url : this.state.avatar_url,
          is_active: true,
        };
      }
    });
    
    return {
      payload: returnValues,
      id: this.state.id
    };
  };
  
  setAvatarImage = (image: Image) => {
    this.setState({
      avatar: image,
      avatar_url: image.path
    });
  };
  
  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form>
        <Row>
          <Col span={24}>
            <Form.Item className={`no-label`}>
              {getFieldDecorator("avatar_url", {})(<Input type={`hidden`}/>)}
              <div style={{textAlign: "center", width: "100%"}}>
                <ImagePicker onSelectImage={this.setAvatarImage} selectedImage={this.state.avatar_url}>
                  <Avatar size={64}
                          src={this.state.avatar_url}
                          icon="user">
                    <Icon type="camera"/>
                  </Avatar>
                </ImagePicker>
              </div>
            </Form.Item>
          
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={<FormattedMessage id="app.name" defaultMessage={`Name`}/>}>
              {getFieldDecorator("name", {
                initialValue: this.state.name,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: <FormattedMessage id="app.name_is_required"
                                             defaultMessage={`Name is required`}/>
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={<FormattedMessage id="app.username" defaultMessage={`Name`}/>}>
              {getFieldDecorator("username", {
                initialValue: this.state.username,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: <FormattedMessage id="app.username_is_required"
                                             defaultMessage={`Username is required`}/>
                }]
              })(<Input disabled/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={<FormattedMessage id="app.mobile" defaultMessage={`Mobile`}/>}>
              {getFieldDecorator("mobile", {
                initialValue: this.state.mobile,
                rules: [{
                  pattern: REGEX_PATTERNS.MOBILE,
                  message: <FormattedMessage id="app.value_is_not_valid"
                                             defaultMessage={`The value is not valid!`}/>
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label={<FormattedMessage id="app.email" defaultMessage={`Email`}/>}>
              {getFieldDecorator("email", {
                initialValue: this.state.email,
                rules: [{
                  type: 'email',
                  message: <FormattedMessage id="app.value_is_not_valid"
                                             defaultMessage={`The value is not valid!`}/>
                }]
              })(<Input/>)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = ({profiles}: ApplicationState, ownProps) => {//
  return {
    loading: profiles && profiles.loading,
    errors: profiles && profiles.errors
    // profile: ownProps.profile ? getUserById(profiles, ownProps.profile.id) : null
    
  }
};

const mapDispatchToProps = {
  updateRequest
};
const WrappedProfileForm = Form.create({name: "profile-form"})(Profile);


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalForm(WrappedProfileForm));

// const WrappedProfileForm = Form.create({name: "profile-form"})(forwardRef(Profile));
// export default Form.create()(forwardRef(Profile));
// export default memo((ModalForm(WrappedProfileForm)));

